export default class CustomerGroup2ManagementColumnModel {
	static CustomerGroup2ManagementColumn = [
	  {
		  title: 'Customer group 2',
		  align: 'left',
		  field: 'group2Name'
	  }
	]
}
